import axios from "axios";

import {FOUR_SET_LOADING, GET_FOUR, PUT_FOUR, GET_GROUP_CODE_4, FOUR_ERROR} from './types'
import {POST_FOUR} from "./actions";

export const getGroupCode4 = () => async (dispatch) => {
    dispatch({ type: FOUR_SET_LOADING })

    const config = {
    headers: {
        'Content-Type': 'application/json',
    },
  };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
    const response = await axios.get(`${process.env.REACT_APP_API}groupcode4/`, config);

    dispatch({
      type: GET_GROUP_CODE_4,
      payload: response.data
    })

  } catch (err) {
    console.log("error: ", JSON.stringify(err))
    dispatch({ type: FOUR_ERROR })
  }
}
// getopk list
export const getFour = (pageID) => async (dispatch) => {
    dispatch({ type: FOUR_SET_LOADING })

    const config = {
    headers: {
        'Content-Type': 'application/json',
    },
  };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
    const response = await axios.get(`${process.env.REACT_APP_GET_FOURS}listed/?page=${pageID}`, config);

    dispatch({
      type: GET_FOUR,
      payload: response.data
    })

  } catch (err) {
    console.log("error: ", JSON.stringify(err))
    dispatch({ type: FOUR_ERROR })
  }
}

export const putFour = (opkID, opkFormData) => async (dispatch) => {
    dispatch({ type: FOUR_SET_LOADING })

    const config = {
    headers: {
        'Content-Type': 'application/json',
    },
  };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
    let response = await axios.put(`${process.env.REACT_APP_GET_FOURS}${opkID}/`, opkFormData, config);
    response.data.id = opkID;
    dispatch({
      type: PUT_FOUR,
      payload: response.data
    })

  } catch (err) {
    console.log("error: ", JSON.stringify(err))
    dispatch({ type: FOUR_ERROR })
  }
}


// // upload xlsx
// export const uploadFile = (xlsxFile) => async (dispatch) => {

//   dispatch({ type: UPLOAD_FILE_SET_LOADING })

//   const config = {
//     responseType: 'arraybuffer',
//     headers: {
//         'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        
//     },
//   };
//     config.headers.Authorization = "JWT " + localStorage.getItem("token");


//   try {
//     const response = await axios.post(process.env.REACT_APP_UPLOAD_FILE, xlsxFile, config);

//     dispatch({
//       type: UPLOAD_FILE,
//       payload: response
//     })
    

//   } catch (err) {
//   console.log("error: ", JSON.stringify(err))
// }

// // upload xlsx
// export const importFileData = (fileID) => async (dispatch) => {

//   dispatch({ type: UPLOAD_FILE_SET_LOADING })

//   const config = {
//     responseType: 'arraybuffer',
//     headers: {
//         'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        
//     },
//   };
//     config.headers.Authorization = "JWT " + localStorage.getItem("token");


//   try {
//     const response = await axios.post(`${process.env.REACT_APP_UPLOAD_FILE}${fileID}/import_data_from_file/`,null, config);

//     dispatch({
//       type: IMPORT_FILE_DATA,
//       payload: response
//     })
    

//   } catch (err) {
//   console.log("error: ", JSON.stringify(err))
// }


export const postFour = (opkFormData) => async (dispatch) => {
    dispatch({ type: FOUR_SET_LOADING })

    const config = {
    headers: {
        'Content-Type': 'application/json',
    },
  };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
    const response = await axios.post(`${process.env.REACT_APP_GET_FOURS}`, opkFormData, config);

    dispatch({
      type: POST_FOUR,
      payload: response.data
    })

  } catch (err) {
    console.log("error: ", JSON.stringify(err))
    dispatch({ type: FOUR_ERROR })
  }
}